import React, { useState, useEffect } from "react";
import "./style.css";

import CollectionHeader from "../../components/header/CollectionHeader";
import amc_logo_negro from "../../../../../assets/imgs/amc-domestico/Logo_AMC_Negro.png";
import CheckIcon from "../../../../../assets/imgs/amc-domestico/Vector.svg";
import NoCheckIcon from "../../../../../assets/imgs/amc-domestico/NoGen.svg";
import GenIcon from "../../../../../assets/imgs/amc-domestico/gen.svg";

import { useForm } from "react-hook-form";
import { IoIosArrowBack } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const Profiles = ({ profile, setProfile }) => {
  return (
    <>
      <div className="collection-profile">
        <div className="profiles">
          <div className="title">
            <h1>¡Bienvenido!</h1>
            <span>Escoge el tipo de recolección.</span>
          </div>
          <div className="profile-content">
            <div className="profile">
              <input
                type="radio"
                id="first"
                name="first"
                value={1}
                style={{ display: "none" }}
                onChange={(e) => {
                  setProfile(e.target.value);
                }}
              />
              <label
                htmlFor="first"
                className="circle"
                style={profile === 1 ? { backgroundColor: "#035cf7" } : {}}
              >
                <svg
                  width="53"
                  height="52"
                  viewBox="0 0 53 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M41.2226 6.3537L35.9438 3.61053C31.309 1.20438 28.9916 0 26.5 0C24.0084 0 21.691 1.20177 17.0563 3.61053L16.209 4.05205L39.7603 17.3734L50.3601 12.1222C48.6551 10.2098 45.9048 8.78075 41.2226 6.34847M52.2288 15.5812L41.6765 20.8063V28.7379C41.6765 29.2576 41.468 29.756 41.0967 30.1235C40.7255 30.4909 40.222 30.6973 39.697 30.6973C39.172 30.6973 38.6685 30.4909 38.2972 30.1235C37.926 29.756 37.7174 29.2576 37.7174 28.7379V22.7657L28.4796 27.3376V52C30.3746 51.5324 32.531 50.4142 35.9438 48.6403L41.2226 45.8971C46.8999 42.9476 49.7399 41.4741 51.3182 38.8223C52.894 36.1732 52.894 32.8736 52.894 26.2822V25.9765C52.894 21.0309 52.894 17.9377 52.2288 15.5812ZM24.5205 52V27.3376L0.771207 15.5812C0.106079 17.9377 0.106079 21.0309 0.106079 25.9713V26.2769C0.106079 32.8736 0.106079 36.1732 1.6818 38.8223C3.26015 41.4741 6.10014 42.9502 11.7775 45.8997L17.0563 48.6403C20.469 50.4142 22.6254 51.5324 24.5205 52ZM2.6399 12.1248L26.5 23.9335L35.503 19.4791L12.0493 6.21262L11.7775 6.3537C7.09783 8.78336 4.34495 10.2124 2.6399 12.1274"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="profile-label">
                <span>Maximo 3 Guías</span>
              </div>
            </div>
            <div className="profile">
              <input
                type="radio"
                id="second"
                name="second"
                value={2}
                style={{ display: "none" }}
                onChange={(e) => {
                  setProfile(e.target.value);
                }}
              />
              <label
                htmlFor="second"
                className="circle"
                style={profile === 2 ? { backgroundColor: "#035cf7" } : {}}
              >
                <svg
                  width="53"
                  height="52"
                  viewBox="0 0 53 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.106079 52V11.5556L26.5 0L52.894 11.5556V52H37.0576V28.8889H15.9424V52H0.106079ZM18.5818 52V46.2222H23.8606V52H18.5818ZM23.8606 43.3333V37.5556H29.1394V43.3333H23.8606ZM29.1394 52V46.2222H34.4182V52H29.1394Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="profile-label">
                <span>Más de 3 Guías</span>
              </div>
            </div>
          </div>
          <div className=""></div>
        </div>
      </div>
    </>
  );
};

const LimitedGuidesForm = ({ setProfile }) => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [inputs, setInputs] = useState([]);
  const [show, setShow] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [modalType, setModalType] = useState("spinner");
  const [turn, setTurn] = useState(null);
  const [awbFail, setAwbFail] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    unregister,
    watch,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const formatAWB = (value) => {
    return value
      .replace(/[^0-9-]/g, "") // Elimina caracteres no válidos
      .replace(/-+/g, "-") // Reemplaza múltiples guiones por uno solo
      .replace(/^(\d{3})(\d+)/, "$1-$2"); // Inserta guión después de los primeros 3 números
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = formatAWB(value);
    setValue(name, formattedValue, { shouldValidate: true });
  };

  const handleShow = (type) => {
    setModalType(type);
    setShow(true);
  };

  const handleConfirm = () => {
    setIsConfirmed(true); // Marca como confirmado
    handleShow("spinner"); // Muestra el spinner

    setTimeout(() => {
      printContent("ticket-content", "8cm 10cm");
    }, 1000);
  };

  const generateInfoTurn = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/client`,
        {
          awbs: awbFail,
          user_id: `${localStorage.getItem("collection-email")}`,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setTurn(res.data.data);
        handleConfirm();
      } else {
        throw new Error(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    reset();
    setIsConfirmed(false);
    setTurn(null);
    setShow(false);
    setProfile("");
  };

  const handleFinalizarTurno = async (data) => {
    const awb = [];
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === "string" && value.trim() !== "") {
        awb.push(value);
      }
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/client/searchAwb`,
        { awbs: awb, user_id: `${localStorage.getItem("collection-email")}` },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        if (res.data.data.message === "The guides haven't arrived yet.") {
          setTurn(res.data.data);
          handleShow("confirm");
          setAwbFail(awb);
        } else {
          setTurn(res.data.data);
          handleShow("confirm");
        }
      } else {
        throw new Error(res);
      }
    } catch (error) {
      if (error.response.data.code === 0) {
        handleShow("exit");
      }
      console.error(error.response);
    }
  };

  const printContent = async (elementId, size, onPrintClose) => {
    const element = document.getElementById(elementId);

    if (element) {
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        console.error(
          "No se pudo abrir la ventana de impresión. Asegúrate de que las ventanas emergentes no están bloqueadas."
        );
        return;
      }

      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules || [])
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (err) {
            return "";
          }
        })
        .join("\n");

      printWindow.document.open();
      printWindow.document.write(`
          <html>
            <head>
              <title>Imprimir</title>
              <style>
                ${styles}
                @page { size: ${size}; margin: 0; }
              </style>
            </head>
            <body onload="window.print(); window.close();">
              ${element.outerHTML}
            </body>
          </html>
        `);
      printWindow.document.close();

      const checkClosed = setInterval(() => {
        if (printWindow.closed) {
          clearInterval(checkClosed);
          handleClose();
          if (onPrintClose) onPrintClose();
        }
      }, 500);
    } else {
      console.error("Elemento no encontrado:", elementId);
    }
  };

  const ConfirmationModal = () => {
    if (turn?.awbWait?.length === 0) {
      return (
        <Modal
          show={show && modalType === "confirm"}
          onHide={() => {}}
          backdrop="static"
          keyboard={false}
          centered
          className="custom-modal-confirm"
        >
          <Modal.Body className="text-center">
            {/* Icono */}
            <div className="modal-icon">
              <img src={CheckIcon} alt="checkImg" />
            </div>
            <p className="modal-text" style={{ textAlign: "center" }}>
              Todas sus guías han sido encontradas exitosamente.
            </p>
            {/* Botones */}
            <div className="modal-buttons">
              <Button onClick={handleConfirm} className="confirm-button">
                Confirmar
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      );
    } else {
      return (
        <Modal
          show={show && modalType === "confirm"}
          onHide={() => {}}
          backdrop="static"
          keyboard={false}
          centered
          className="custom-modal-confirm"
        >
          <Modal.Body className="text-center">
            {/* Icono */}
            <div className="modal-icon">
              <svg
                width="139"
                height="129"
                viewBox="0 0 139 129"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M60.5429 24.3527C67.9325 28.8887 73.3255 35.7744 75.7294 43.7421C78.1333 51.7098 77.3863 60.2234 73.6257 67.7157C80.3401 72.5623 88.5134 75.3015 96.9837 75.544C105.454 75.7864 113.79 73.5197 120.808 69.0662C127.825 64.6126 133.166 58.1988 136.072 50.7364C138.978 43.2741 139.301 35.1429 136.995 27.4986C134.688 19.8544 129.87 13.0862 123.225 8.15608C116.581 3.22593 108.447 0.384739 99.981 0.0363606C91.5149 -0.312018 83.1471 1.85015 76.067 6.21552C68.9869 10.5809 63.5548 16.9273 60.5429 24.3527ZM98.2305 34.2871C101.66 34.2871 104.444 36.8966 104.444 40.1117V56.8307C104.444 58.3755 103.789 59.857 102.624 60.9493C101.459 62.0417 99.8784 62.6553 98.2305 62.6553C96.5826 62.6553 95.0023 62.0417 93.837 60.9493C92.6718 59.857 92.0172 58.3755 92.0172 56.8307V40.1117C92.0172 36.8966 94.8008 34.2871 98.2305 34.2871ZM90.9435 19.5625C90.9435 23.9519 94.8206 25.881 97.5545 26.1606L98.2504 26.1979C100.964 26.1979 105.547 24.334 105.547 19.5625C105.547 15.1638 101.67 13.2346 98.9364 12.9551L98.2405 12.9178C95.5265 12.9178 90.9435 14.7817 90.9435 19.5625ZM40.4116 75.8329C43.6378 75.8942 46.8445 75.3514 49.8441 74.2364C52.8436 73.1213 55.5757 71.4565 57.8804 69.3393C60.1851 67.2222 62.0159 64.6952 63.2659 61.9065C64.5158 59.1177 65.1596 56.1232 65.1596 53.0983C65.1596 50.0734 64.5158 47.0789 63.2659 44.2901C62.0159 41.5014 60.1851 38.9744 57.8804 36.8573C55.5757 34.7401 52.8436 33.0753 49.8441 31.9602C46.8445 30.8452 43.6378 30.3024 40.4116 30.3637C34.0647 30.4841 28.021 32.9323 23.5777 37.1828C19.1345 41.4332 16.6458 47.1472 16.6458 53.0983C16.6458 59.0494 19.1345 64.7634 23.5777 69.0138C28.021 73.2643 34.0647 75.7125 40.4116 75.8329ZM5.34118e-05 121.293C-0.0164364 111.78 3.78577 102.609 10.6511 95.603C17.5163 88.5971 26.9421 84.2691 37.0552 83.4789C47.1682 82.6888 57.2282 85.4944 65.2359 91.3383C73.2436 97.1822 78.6128 105.636 80.2765 115.021H131.544C133.521 115.021 135.418 115.757 136.816 117.068C138.214 118.379 139 120.157 139 122.01C139 123.864 138.214 125.642 136.816 126.953C135.418 128.264 133.521 129 131.544 129H7.65489C5.76726 129 3.95007 128.328 2.56998 127.121C1.18989 125.913 0.349639 124.26 0.218763 122.495C0.0793337 122.108 0.00880301 121.702 0.00999476 121.293H5.34118e-05Z"
                  fill="#020C41"
                />
              </svg>
            </div>
            {/* Texto */}
            {turn?.message ? (
              <p className="modal-text" style={{ textAlign: "center" }}>
                Las guías{" "}
                <strong>
                  {turn?.awbWait?.join(", ").replace(/,([^,]*)$/, " y$1")}
                </strong>{" "}
                no han llegado al almacén. Regrese mas tarde o consulte la
                pagina web
                <br />
                <a
                  href="https://amcargo.aeromexico.com/"
                  style={{ color: "#000000", fontWeight: "bold" }}
                >
                  amcargo.aeromexico.com.
                </a>
                <br />
                <br />
                Si desea consultar con alguno de nuestros agentes, espere su
                turno.
                <br />
                <br />
                <span style={{ color: "#035cf7", fontWeight: "bold" }}>
                  ¿Desea generar su turno?
                </span>
              </p>
            ) : (
              <p className="modal-text" style={{ textAlign: "center" }}>
                La guía{" "}
                <strong>
                  {turn?.awbWait?.join(", ").replace(/,([^,]*)$/, " y$1")}{" "}
                </strong>{" "}
                no ha llegado al almacén.
                <br />
                <br />
                <br />
                El resto de sus guías ya se encuentran en el almacén
              </p>
            )}
            {/* Botones */}
            <div className="modal-buttons">
              {turn?.message ? (
                <>
                  <Button
                    onClick={handleClose}
                    style={{
                      borderRadius: "0px",
                      border: "none",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "20px",
                      backgroundColor: "#ed544e",
                      color: "#ffffff",
                      fontWeight: "bold",
                    }}
                  >
                    No generar
                    <img
                      src={NoCheckIcon}
                      alt="No generar"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </Button>
                  <Button
                    onClick={generateInfoTurn}
                    style={{
                      borderRadius: "0px",
                      border: "none",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "20px",
                      backgroundColor: "#5cb46f",
                      color: "#ffffff",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Generar
                    <img
                      src={GenIcon}
                      alt="generar"
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </Button>
                </>
              ) : (
                <>
                  <Button onClick={handleConfirm} className="confirm-button">
                    Confirmar
                  </Button>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      );
    }
  };

  const addInput = () => {
    if (inputs.length >= 2) {
      Swal.fire({
        icon: "warning",
        title: "Máximo 3 guías",
      });
      return;
    }
    setInputs((prev) => [...prev, ""]);
  };

  const removeInput = (indexToRemove) => {
    const updatedInputs = [...inputs];

    // Mueve los valores hacia arriba
    for (let i = indexToRemove; i < updatedInputs.length - 1; i++) {
      const nextValue = watch(`awb${i + 1}`);
      setValue(`awb${i}`, nextValue || "");
    }

    // Borra el último valor sobrante
    const lastIndex = updatedInputs.length - 1;
    unregister(`awb${lastIndex}`);
    setInputs((prev) => prev.filter((_, i) => i !== lastIndex));
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];
      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();
      return `${dayName}, ${day} de ${monthName} ${year}`;
    }
    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");
      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }
    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="form-body">
        <form onSubmit={handleSubmit(handleFinalizarTurno)}>
          <div className="form-container">
            <div className="title">
              <h1>¡Bienvenido!</h1>
              <span>
                Para agilizar la entrega de su mercancía, ayudenos ingresando
                sus números de guía
              </span>
            </div>
            <div className="form">
              {/* Guia 1 */}
              <div className="formGroup">
                <input
                  className="formInput"
                  type="text"
                  name="awb"
                  id="awb"
                  placeholder=""
                  maxLength={12}
                  {...register("awb", {
                    required: "Este campo es requerido",
                    pattern: {
                      value: /^\d{3}-\d{8}$/,
                      message: "Formato No. Guia invalido",
                    },
                  })}
                  onChange={handleChange}
                  value={watch("awb") || ""}
                />
                <label htmlFor="awb" className="formLabel">
                  Guía
                </label>
                {errors.awb && (
                  <span className="alert-text">{errors.awb.message}</span>
                )}
              </div>

              {/* Guias multiples */}
              {inputs.map((_, index) => (
                <div className="duplicateForm" key={index}>
                  <div className="uno">
                    <div className="formGroup multi">
                      <input
                        className="formInput"
                        type="text"
                        name={`awb${index}`}
                        id={`awb${index}`}
                        placeholder=""
                        maxLength={12}
                        {...register(`awb${index}`, {
                          required: "Este campo es requerido",
                          pattern: {
                            value: /^\d{3}-\d{8}$/,
                            message: "Formato No. Guia invalido",
                          },
                        })}
                        onChange={handleChange}
                        value={watch(`awb${index}`) || ""}
                      />
                      <label htmlFor={`awb${index}`} className="formLabel">
                        Guía
                      </label>

                      {errors[`awb${index}`] && (
                        <span className="alert-text">
                          {errors[`awb${index}`].message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="dos">
                    <div className="rem-cont">
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => removeInput(index)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              <div className="addButton">
                <button type="button" onClick={addInput}>
                  <FaPlus /> Agrega guía
                </button>

                <button type="submit" className="save">
                  Finalizar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Modal de Confirmación */}
      {ConfirmationModal()}

      <Modal show={show && modalType === "spinner"} className="custom-modal">
        <Modal.Body className="text-center">
          <div className="custom-spinner">
            <div className="progress-circle"></div>
          </div>
          <p>Procesando turno</p>

          <div className="hiden-turn" id="hiden-turn">
            <div id="ticket-content">
              <div className="amc-collection-ticket">
                <div className="amc-collection-ticket-header">
                  <div className="amc-collection-ticket-header-icon">
                    <img src={amc_logo_negro} alt="logo amc" />
                  </div>
                  <div className="amc-collection-ticket-header-hour">
                    <div className="amc-collection-ticket-header-hour-date">
                      <p>{currentDate}</p>
                    </div>
                    <div className="amc-collection-ticket-header-date">
                      <p>{currentTime}</p>
                    </div>
                  </div>
                </div>
                <div className="amc-collection-ticket-body">
                  <h5>Turno</h5>
                  <p>{turn?.turn}</p>
                  <h5>Numeros de Guías</h5>
                  {turn?.awbExist?.length > 0
                    ? turn?.awbExist?.map((awb, index) => (
                        <p key={index}>{awb}</p>
                      ))
                    : ""}
                  {turn?.awbs?.length > 0
                    ? turn?.awbs?.map((awb, index) => <p key={index}>{awb}</p>)
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show && modalType === "exit"}
        onHide={handleClose}
        className="custom-modal"
      >
        <Modal.Body className="text-center">
          <h3 className="modal-text">
            Por favor, Revise los datos ingresados.
          </h3>
          <Button onClick={handleClose} className="exit-button">
            Salir
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UnlimitedGuidesForm = ({ setProfile }) => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [show, setShow] = useState(false);
  const [modalType, setModalType] = useState("spinner");
  const [turn, setTurn] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleShow = (type) => {
    setModalType(type);
    setShow(true);
  };

  const handleClose = () => {
    setTurn(null);
    setShow(false);
    setProfile("");
  };

  const handleFinalizarTurno = async (data) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/client/searchCustomer/${data.account}`,
        { user_id: `${localStorage.getItem("collection-email")}` },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        }
      );

      if (
        res.data.code === 1 &&
        res.data.data.message === "El numero de cliente no existe"
      ) {
        handleShow("exit");
      } else if (res.data.code === 1) {
        setTurn(res.data.data);
        setShow(true);
        handleShow("spinner");
        setTimeout(() => {
          printContent("ticket-content", "8cm 10cm");
        }, 1000);
      } else {
        throw new Error(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const printContent = async (elementId, size, onPrintClose) => {
    const element = document.getElementById(elementId);

    if (element) {
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        console.error(
          "No se pudo abrir la ventana de impresión. Asegúrate de que las ventanas emergentes no están bloqueadas."
        );
        return;
      }

      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules || [])
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (err) {
            return "";
          }
        })
        .join("\n");

      printWindow.document.open();
      printWindow.document.write(`
          <html>
            <head>
              <title>Imprimir</title>
              <style>
                ${styles}
                @page { size: ${size}; margin: 0; }
              </style>
            </head>
            <body onload="window.print(); window.close();">
              ${element.outerHTML}
            </body>
          </html>
        `);
      printWindow.document.close();

      const checkClosed = setInterval(() => {
        if (printWindow.closed) {
          clearInterval(checkClosed);
          handleClose();
          if (onPrintClose) onPrintClose();
        }
      }, 500);
    } else {
      console.error("Elemento no encontrado:", elementId);
    }
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];
      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();
      return `${dayName}, ${day} de ${monthName} ${year}`;
    }
    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");
      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }
    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="form-body">
        <form onSubmit={handleSubmit(handleFinalizarTurno)}>
          <div className="form-container">
            <div className="title">
              <h1>¡Bienvenido!</h1>
              <span>
                Para agilizar la entrega de su mercancía, ayudenos ingresando el
                nombre del cliente
              </span>
            </div>
            <div className="form">
              {/* Numero de Cuenta */}
              <div className="formGroup">
                <input
                  className="formInput"
                  type="text"
                  name="account"
                  id="account"
                  placeholder=""
                  {...register("account", {
                    required: "Este campo es requerido",
                    // pattern: {
                    //   value: /^\d{3}-\d{8}$/,
                    //   message: "Formato No. Guia invalido",
                    // },
                  })}
                />
                <label htmlFor="account" className="formLabel">
                  Numero de cuenta
                </label>
                {errors.account && (
                  <span className="alert-text">{errors.account.message}</span>
                )}
              </div>
              <div className="addButton">
                <button type="submit" className="save">
                  Finalizar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Modal show={show && modalType === "spinner"} className="custom-modal">
        <Modal.Body className="text-center">
          <div className="custom-spinner">
            <div className="progress-circle"></div>
          </div>
          <p>Procesando turno</p>

          <div className="hiden-turn" id="hiden-turn">
            <div id="ticket-content">
              <div className="amc-home-ticket">
                <div className="amc-home-ticket-header">
                  <div className="amc-home-ticket-header-icon">
                    <img src={amc_logo_negro} alt="logo amc" />
                  </div>
                  <div className="amc-home-ticket-header-hour">
                    <div className="amc-home-ticket-header-hour-date">
                      <p>{currentDate}</p>
                    </div>
                    <div className="amc-home-ticket-header-date">
                      <p>{currentTime}</p>
                    </div>
                  </div>
                </div>
                <div className="amc-home-ticket-body">
                  <h5>Turno</h5>
                  <p>{turn?.turn}</p>
                  <h5>Nombre del Cliente</h5>
                  <p>{turn?.customer_name}</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show && modalType === "exit"}
        onHide={handleClose}
        className="custom-modal"
      >
        <Modal.Body className="text-center">
          <h3 className="modal-text">
            El número de cuenta introducido no se encuentra registrado, favor de
            revisarlo o pasar con el supervisor para darlo de alta.
          </h3>
          <Button onClick={handleClose} className="exit-button">
            Salir
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ClientsCollection = () => {
  const [profile, setProfile] = useState("");

  return (
    <>
      <div className="clients-collection-container">
        <CollectionHeader />
        <div className="clients-collection-body">
          {profile ? (
            <div className="return-container">
              <button
                type="button"
                className="return-btn"
                onClick={() => setProfile("")}
              >
                <IoIosArrowBack className="arrow-btn" />
              </button>
            </div>
          ) : (
            ""
          )}
          {!profile ? (
            <Profiles profile={profile} setProfile={setProfile} />
          ) : (
            <>
              {profile == 1 && <LimitedGuidesForm setProfile={setProfile} />}
              {profile == 2 && <UnlimitedGuidesForm setProfile={setProfile} />}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ClientsCollection;
